/**
 * The refusals of a kit call that the Assets tab shows in its own way. `customBaseQuery` puts the
 * REST `cause` on the error as `m24Limit`.
 */
export type KitRefusal = 'videoCredits' | 'busy' | 'noMaster' | 'other';

function causeOf(error: unknown): Record<string, unknown> | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }
  const cause = (error as { m24Limit?: unknown }).m24Limit;
  return typeof cause === 'object' && cause !== null ? (cause as Record<string, unknown>) : null;
}

/**
 * 402 `M24_LIMIT_QUOTA` with kind `videoCredit` → `videoCredits` (g8 for the owner, e4 for a
 * member); 409 `M24_KIT_ASSET_BUSY` → `busy`; 400 `M24_NO_MASTER` or `M24_MASTER_PROCESSING` →
 * `noMaster` (the k3 upload).
 */
export function kitRefusal(error: unknown): KitRefusal {
  const cause = causeOf(error);
  if (cause === null) {
    return 'other';
  }
  if (cause.code === 'M24_LIMIT_QUOTA' && cause.kind === 'videoCredit') {
    return 'videoCredits';
  }
  if (cause.code === 'M24_KIT_ASSET_BUSY') {
    return 'busy';
  }
  const reason = cause.reason ?? cause.code;
  if (reason === 'M24_NO_MASTER' || reason === 'M24_MASTER_PROCESSING') {
    return 'noMaster';
  }
  return 'other';
}
